// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3INJd","rootMobile":"styles_rootMobile__3JELN"};